import gql from 'graphql-tag';

export const GET_LENDER_PERFORMANCE_TREND_BY_LENDER = gql`
  query LenderPerformanceTrendByLender($input: LenderPerformanceReportInput!) {
    lenderPerformance {
      result: trendByLender(input: $input) {
        success
        error
        entity {
          lenderProfileId
          lenderName
          points {
            month
            submitted
            approved
            approvalRate
            funded
            fundRate
            lookToBook
          }
        }
      }
    }
  }
`;
